import styled from 'styled-components';
import { Field } from 'formik';

import colors from '../../../styles/colors';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 3px;
  height: 42px;

  color: ${colors.blueEinstein};
  border: 1px solid ${colors.lightgray};

  &[data-success='true'] {
    color: ${colors.blueEinstein};
    border-color: ${colors.blueEinstein};
  }

  &[data-danger='true'] {
    color: ${colors.danger};
    border-color: ${colors.danger};
  }

  &[data-warning='true'] {
    color: ${colors.danger};
    border-color: ${colors.danger};
  }
  overflow: visible;
`;

export const InputLabel = styled.label`
  position: absolute;
  top: -8px;
  left: 10px;
  background: white;
  font-size: 12px;
  z-index: 1;
  padding: 0px 3px;

  &[data-success='true'] {
    color: ${colors.blueEinstein};
    border-color: ${colors.blueEinstein};
  }

  &[data-danger='true'] {
    color: ${colors.danger};
    border-color: ${colors.danger};
  }

  &[data-warning='true'] {
    color: ${colors.danger};
    border-color: ${colors.danger};
  }
`;

export const InputStyled = styled(Field)`
  border: none;
  padding: 10px;
  width: 100%;
  height: 100%;
  overflow: visible;
  border-radius: 3px;
  color: ${colors.gray};
  font-size: 16px;

  &::placeholder {
    color: ${colors.graysecondary};
  }
`;

export const InputError = styled.span`
  position: absolute;
  bottom: -15px;
  left: 10px;
  font-size: 12px;
  color: ${colors.danger};
  font-weight: 400;
`;

export const HidePasswordContainer = styled.div`
  position: absolute;

  margin-left: 250px;
  background: transparent;
  height: 40px;
  width: 50px;

  border-left: 0px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HidePasswordAction = styled.button.attrs({
  type: 'button',
})`
  background: transparent;
  border: none;

  cursor: pointer;
`;
